export const comments_5129828 = {"data":{"data":[],"links":{}}}